import { useQuery } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { requetes } from '../api'
import { TableauCartes } from '../composants/DecisionPayeur'
import { ARefacturer, DepenseSansPiece, LotsRefacturation } from '../composants/Refacturations'
import { EntetePage, Filtre } from '../composants/Ui'

// Frais à refacturer : ce qu'une entité a réglé pour une autre ou pour un tiers, en attente
// d'être réuni en lot ; puis les lots préparés et leur remboursement.

export function Refacturations({ entiteId }: { entiteId?: string | undefined }) {
  const navigate = useNavigate()
  const entites = useQuery(requetes.entites).data ?? []
  return (
    <main>
      <EntetePage surtitre="Paiements" titre="Frais à refacturer" />
      <div className="pile" style={{ gap: 16 }}>
        <p className="discret">
          Chaque pièce à se faire rembourser par une autre entité ou par un tiers. Un lot les réunit
          d’un coup : un PDF (récapitulatif puis justificatifs), le remboursement attendu, la tâche
          pour le transmettre et, si une adresse est connue, le courriel préparé.
        </p>
        <div className="rangee-filtres" style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Filtre
            icone="domain"
            libelle="Entité"
            valeur={entiteId ?? ''}
            onChange={(v) => navigate({ to: '/refacturations', search: v ? { entiteId: v } : {} })}
            options={[
              { valeur: '', libelle: 'Toutes les entités' },
              ...entites.filter((e) => !e.archivee).map((e) => ({ valeur: e.id, libelle: e.nom })),
            ]}
          />
        </div>
        <ARefacturer key={entiteId ?? 'toutes'} entiteId={entiteId} />
        <DepenseSansPiece entiteId={entiteId} />
        <LotsRefacturation entiteId={entiteId} />
        <TableauCartes />
      </div>
    </main>
  )
}
